/* MSW Free Shipping Bar — deferred external script */
(function() {
  'use strict';

  function updateFreeShippingBar() {
    fetch(window.Shopify.routes.root + 'cart.js', { cache: 'no-store' })
      .then(function(response) { return response.json(); })
      .then(function(cart) {
        // Check sessionStorage cache first
        var cached = null;
        try { cached = sessionStorage.getItem('msw_geo_iso'); } catch(e) {}

        if (cached) {
          applyShippingLogic(cached, cart);
        } else {
          fetch('https://get.geojs.io/v1/ip/country.json')
            .then(function(res) { return res.json(); })
            .then(function(data) {
              var isoCode = data.country;
              try { sessionStorage.setItem('msw_geo_iso', isoCode); } catch(e) {}
              applyShippingLogic(isoCode, cart);
            })
            .catch(function(err) {
              console.error("GeoIP Failed, defaulting to International logic.", err);
              applyShippingLogic(null, cart);
            });
        }
      })
      .catch(function(err) { console.error('Error loading cart:', err); });
  }

  function applyShippingLogic(isoCode, cart) {
    var cleanIso = isoCode ? isoCode.trim().toUpperCase() : '';
    var isCanada = cleanIso === 'CA';
    var isUS = cleanIso === 'US';

    // Expose region globally for other scripts
    window.mswGeoRegion = isUS ? 'US' : isCanada ? 'CA' : 'INTL';

    var fills = document.querySelectorAll('.shipping-bar-fill');
    var messages = document.querySelectorAll('#shipping-message');
    var containers = document.querySelectorAll('.shipping-bar-container');

    // === INTERNATIONAL (NOT US OR CA) ===
    if (!isCanada && !isUS) {
      containers.forEach(function(el) {
        el.style.display = 'none';
        el.style.visibility = 'hidden';
      });
      messages.forEach(function(msg) {
        msg.style.display = 'block';
        msg.style.visibility = 'visible';
        if (msg.parentElement) msg.parentElement.style.display = 'block';
        msg.innerHTML = "Duties & Customs Included in Shipping Price";
      });
      applyUpsellRegion('INTL');
      return;
    }

    // === CANADA LOGIC ===
    if (isCanada) {
      var threshold = 10000;
      var total = cart.total_price;
      var percentage = Math.min((total / threshold) * 100, 100);

      containers.forEach(function(el) {
        el.style.display = 'block';
        el.style.visibility = 'visible';
        if (el.parentElement) el.parentElement.style.display = 'block';
      });
      fills.forEach(function(fill) { fill.style.width = percentage + '%'; });

      var formatter = new Intl.NumberFormat('en-CA', {
        style: 'currency',
        currency: 'CAD',
        maximumFractionDigits: 0
      });

      messages.forEach(function(msg) {
        msg.style.display = 'block';
        msg.style.visibility = 'visible';
        if (msg.parentElement) msg.parentElement.style.display = 'block';

        if (cart.item_count === 0) {
          msg.innerHTML = "Free Shipping on Orders $100+";
        } else if (total >= threshold) {
          msg.innerHTML = "You've earned FREE shipping!";
        } else {
          var remaining = (threshold - total) / 100;
          msg.innerHTML = "Only " + formatter.format(remaining) + " away from Free Shipping";
        }
      });

      applyUpsellRegion('CA');

    } else if (isUS) {
      // === USA LOGIC ===
      var threshold = 5000;
      var total = cart.total_price;
      var percentage = Math.min((total / threshold) * 100, 100);

      containers.forEach(function(el) {
        el.style.display = 'block';
        el.style.visibility = 'visible';
        if (el.parentElement) el.parentElement.style.display = 'block';
      });
      fills.forEach(function(fill) { fill.style.width = percentage + '%'; });

      messages.forEach(function(msg) {
        msg.style.display = 'block';
        msg.style.visibility = 'visible';
        if (msg.parentElement) msg.parentElement.style.display = 'block';

        if (cart.item_count === 0) {
          msg.innerHTML = "Free Shipping on Orders $50+";
        } else if (total >= threshold) {
          msg.innerHTML = "You've earned FREE shipping!";
        } else {
          var remaining = (threshold - total) / 100;
          var formattedRemaining = remaining % 1 === 0 ? '$' + remaining.toFixed(0) : '$' + remaining.toFixed(2);
          msg.innerHTML = "Only " + formattedRemaining + " away from Free Shipping";
        }
      });

      applyUpsellRegion('US');
    }
  }

  // Update upsell toggle shipping labels based on region
  function applyUpsellRegion(region) {
    var subtitle = document.getElementById('combo-upsell-subtitle');
    var labelPaid = document.getElementById('upsell-label-paid');
    var labelFree = document.getElementById('upsell-label-free');
    var noBtn = document.querySelector('#combo-upsell-toggle [data-value="no"]');
    var yesBtn = document.querySelector('#combo-upsell-toggle [data-value="yes"]');

    if (region === 'US') {
      // US: show shipping labels in toggle
      if (labelPaid) labelPaid.style.display = '';
      if (labelFree) labelFree.style.display = '';
      if (noBtn) noBtn.style.justifyContent = 'space-between';
      if (yesBtn) yesBtn.style.justifyContent = 'space-between';
      if (subtitle) subtitle.textContent = 'Unleash your style and unlock Free Shipping!';
    } else {
      // Non-US: hide shipping labels, center text, change subtitle
      if (labelPaid) labelPaid.style.display = 'none';
      if (labelFree) labelFree.style.display = 'none';
      if (noBtn) noBtn.style.justifyContent = 'center';
      if (yesBtn) yesBtn.style.justifyContent = 'center';
      if (subtitle) subtitle.textContent = 'Unleash your style by adding an extra strap!';
    }
  }

  // Expose globally so other scripts can trigger updates
  window.updateFreeShippingBar = updateFreeShippingBar;

  // Run on DOM ready
  document.addEventListener('DOMContentLoaded', function() {
    updateFreeShippingBar();
  });

  // PubSub Listener (Shopify Standard)
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      setTimeout(updateFreeShippingBar, 100);
    });
  }

  // Drawer Observer (For Ajax Carts)
  var cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    var drawerObserver = new MutationObserver(function() { updateFreeShippingBar(); });
    drawerObserver.observe(cartDrawer, { attributes: true, subtree: true });
  }
})();
